import React from 'react'
import { GetImages } from '../../../utils/GetImages'
import DateHelper from '../../../utils/DateHelper'
import EmptyState from '../../../newComponents/emptystate'

const CreditCheckInfo = ({ CreditCheck }) => {
  return (
    <>
    {
      CreditCheck ? (
        <div className="creditcheck">
          
          <div className="creditcheck_left gap-2">
            <div>
              <p className="normal_text fw-bold black pb-2">{CreditCheck?.taxIdNumber}</p>
              <p className="normal_text black">Social Security Number  </p>
            </div>
             <div className='BorderLeft mx-2'/>
          <div className="">          
            <p className="normal_text black fw-bold">
              {DateHelper.convertUTCtoDateTime2(CreditCheck?.dateOfBirth )}
            </p>
            <p className="normal_text  black">DOB</p>
          </div>
          </div>
         
          <div className="creditcheck_right">
            <div className={`statusSign ${CreditCheck?.consentToRunCheck ? "successborder" : "errorborder"}`}>
              <img alt="status" className="iconstyle10"
                src={CreditCheck?.consentToRunCheck
                  ? GetImages.greenTick : GetImages.closeRedIcon} />
            </div>
            <p className="normal_text black">

              Credit Check Authorization Consent
            </p>
           
          </div>
        </div>
      ) : (<EmptyState heading="Data not found" isButton={false} isBorder={false} />)
    }</>
  )
}

export default CreditCheckInfo